import { DateTime } from "luxon";

export function getLastTwoMonthsDateRange() {
  const now = DateTime.now();
  const start = now.minus({ month: 1 }).set({ day: 1 });
  const end = now;

  return { start, end };
}
